export const humanizedWeeksAndDays = (totalDays, lexicon, wholeWeekOnly) => {
  if (totalDays === 0) return `0 ${lexicon.get('day')}`

  const weeks = Math.floor(totalDays / 7)
  const days = totalDays % 7

  let weekStr = ''
  if (weeks === 1) weekStr = `1 ${lexicon.get('week')}`
  else if (weeks > 1) weekStr = `${weeks} ${lexicon.get('weeks')}`

  let dayStr

  if (days === 0 && wholeWeekOnly) dayStr = ''
  else if (days === 0) dayStr = lexicon.get('0_day')
  else if (days === 1) dayStr = `1 ${lexicon.get('day')}`
  else dayStr = `${days} ${lexicon.get('days')}`

  if (weekStr && dayStr) return `${weekStr}${lexicon.get('and')}${dayStr}`
  if (weekStr) return weekStr
  if (dayStr) return dayStr

  // TODO: eslint (consistent-return): is this an adequate fallback string for a time display?
  return 'n/a'
}
